import { useEffect, useRef } from "react";

export const useMouseDownOutside = (
  cb: () => void,
  additionalRoot?: HTMLElement
) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const portalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const act = ({ target }: MouseEvent) => {
      const node = target as Node;
      const inRefs =
        containerRef.current?.contains(node) ||
        portalRef.current?.contains(node) ||
        additionalRoot?.contains(node);
      const inPopover = (target as Element).closest?.("[data-popover]");
      if (!inRefs && !inPopover) cb();
    };

    // A mousedown inside an iframe never reaches this document, so a click on
    // an embedded page can't dismiss the menu directly. Focus does move into
    // the iframe though, blurring the window — treat that as an outside click.
    const onBlur = () => {
      if (document.activeElement?.tagName === "IFRAME") cb();
    };

    document.addEventListener("mousedown", act, true);
    window.addEventListener("blur", onBlur);
    return () => {
      document.removeEventListener("mousedown", act, true);
      window.removeEventListener("blur", onBlur);
    };
  }, [cb, additionalRoot]);

  return [containerRef, portalRef] as const;
};
